import { z } from 'zod';
import { idSchema } from './common.schemas';

/** Fixed vocabulary, not per-tenant config — same shape as BILLING_PREFERENCES. */
export const UPLOAD_CONTENT_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'application/pdf'] as const;
export type UploadContentType = (typeof UPLOAD_CONTENT_TYPES)[number];

export const MAX_UPLOAD_SIZE_BYTES = 25 * 1024 * 1024;

/** `POST /uploads` — the id it's for is caller-supplied text (job, expense, a future truck…), not a closed set. */
export const createUploadSchema = z.object({
  entityType: idSchema,
  entityId: idSchema,
  contentType: z.enum(UPLOAD_CONTENT_TYPES),
  sizeBytes: z.number().int().positive().max(MAX_UPLOAD_SIZE_BYTES),
});
export type CreateUploadInput = z.infer<typeof createUploadSchema>;
